<style src="./Burger.scss" lang="scss"></style>

<script>
	import TreeList from '@/components/TreeList/TreeList';

	/**
	 * Burger menu in navigation.
	 * @vue-data {boolean} hover If Burger menu is hovered
	 * @vue-data {string | number} timer Timer id for hover state
	 * @vue-data {string} id An unique identifier for the component instance
	 * @vue-data {Object[]} elements An array of objects to fill menu with
	 * @listens Document#click
	 */
	export default {
		name: 'HpBurger',
		props: {
			elements: Array
		},
		data () {
			return {
				hover: false,
				timer: '',
				id: this._uid,
				brand: ''
			};
		},
		methods: {
			/**
			 * To burger or not to burger: That is the question.
			 * @private
			 */
			toBurgerOrNotToBurger () {
				this.$el.querySelector('label').setAttribute('data-burger', 'true');
				clearInterval(this.timer);
			},
			close () {
				const checkbox = this.$el.querySelector('input[type=checkbox]:checked');

				if (checkbox) {
					checkbox.checked = false;
				}
			}
		},
		watch: {
			hover: function (val) {
				if (this.hover) {
					this.timer = setInterval(this.toBurgerOrNotToBurger, 25000);
				} else {
					this.$el.querySelector('label').removeAttribute('data-burger');
					clearInterval(this.timer);
				}
			}
		},
		components: {
			'hp-tree-list': TreeList
		},
		created () {
			this.brand = process.env.VUE_APP_BRAND;
			// HOMEPAGE-4065: safari has a render bug when rotate the device
			// it doesn't set the fixed burger menu to the left => trigger rerendering
			window.addEventListener('orientationchange', () => {
				const layer = this.$el.querySelector('[data-layer]');
				layer && (layer.style.display = 'none');
				setTimeout(() => {
					layer && (layer.style.display = '');
				}, 0);
			});
		}
	};
</script>

<template>
	<div data-component="burger">
		<input type="checkbox" :id="'burger' + id" data-hidden />
		<label :for="'burger' + id" @mouseenter="hover = true" @mouseleave="hover = false">
			<span></span>
			<span><div></div></span>
			<span></span>
		</label>
		<div data-layer>
			<div data-part="scrollable-container">
				<div data-part="logo">
					<svg v-if="brand === 'webde'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
						<path fill="#FFD800" d="M49 56H7c-3.85 0-7-3.15-7-7V7c0-3.85 3.15-7 7-7h42c3.85 0 7 3.15 7 7v42c0 3.85-3.15 7-7 7z" />
						<path
							fill="#333333"
							d="M12.628 17.196c.45.166 1.048-.134 1.481-.211.43-.075 2.19-.47 1.857-.069-.187.226-.67.227-1.1.353-.597.176-1.555.275-1.592 1.043-.085 1.827 2.755.612 3.587.315 2.255-.785 4.84-.92 7.122-1.301 2.532-.421 5.135-.46 7.691-.558 2.69-.103 5.584-.216 8.227.157.704.099 1.37.177 2.086.252.62.064 1.928.633 2.48.372.501-.237.274-.83.533-1.133.373-.435 1.108-.36.597-1.29-.389-.708-1.808-.938-2.542-.794-.073-.447.269-.249.359-.481.13-.335.13-.852-.088-1.224-.394-.677-2.266-.917-2.267-.916-4.491-.723-12.572-1.503-21.173-.5-1.427.167-3.931.345-5.393.937-.647.262-.637.268-.717.692-.077.603.213 1.306.938 1.156 1.389-.286 3.843-.683 4.546-.862 3.469-.883 15.015-.711 16.502-.358.919.196 5.968.362 6.089 1.286-11.782-.488-16.28-.483-26.859.774-.884.146-1.415.339-2.112.575-.859.289-1.44 1.346-.252 1.785z"
						/>
						<path
							fill="#333333"
							d="M28.208 9.892c.412.036 3.667.133 3.854-1.14.106-.722-.608-1.894-.813-2.106-.27-.223-.865 1.722-1.015-.191-.024-.312-.104-.795-.251-1.09-.074-.148-.165-.256-.275-.256a.388.388 0 0 0-.18.062c-.094.061-.228.259-.295.425-.184.454-.265 2.209-.72 2.238-.495.032-.48-1.124-.414-1.46.011-.055-.001-.068-.023-.063-.047.013-.062.022-.1.035-.297.114-.636.459-.661.484-.466.478-1.096 1.725-.778 2.299.331.593 1.323.732 1.671.763zM50.887 34.98c-.035-.249-.108-.402-.277-.631-.613-.839-3.495-1.401-3.496-1.391-1.447-.316-3.114-.588-4.975-.815.265-1.258-.012-3.579-.019-4.386.037-1.441.007-5.166-.102-6.108-.083-.885-.201-1.272-.686-2.004-.348-.523-.455-1.034-1.257-.953-.73.073-.999 1.086-.874 1.702l.314 1.253c.131.259.485 8.386.405 9.094.007.343-.025.785-.035 1.159-1.897-.18-3.96-.319-6.169-.416l.087-.069c1.057-.822.691-1.914.514-3.104-.241-1.905-.057-7.311-.284-7.962-.154-.51-.588-.804-.966-1.193-.466-.48-1.051-.627-1.588-.076-.527.478.132 7.304.169 10.302.048.628-.092 1.415.158 2.022-.204-.008-5.628-.121-6.084-.113.006-.106-.065-.241-.116-.344-.136-.275-.328-.917-.383-1.217a12.788 12.788 0 0 1-.187-1.729c-.041-1.24.074-5.076.212-6.08.155-1.11.746-3.068-1.179-2.637-.208.047-1.228.173-1.501.388-.317.249-.286.873-.298 1.218-.045 1.31-.19 5.438-.182 6.43.01.833.159 1.905.464 2.718.186.494.737.986 1.313 1.297-1.059.029-2.079.063-2.441.083-1.788.1-3.159.199-4.495.33l-.017-.064c-.224-.69.098-3.538.718-8.879.15-1.288-.077-1.339-.861-2.065-.45-.417-.831-.698-1.613-.071-.496.398-.367.909-.452 1.483-.297 2.003-.73 5.149-.914 7.188-.052.563.027 1.851.171 2.632.013.037.008.078.026.118-.776.104-1.557.218-2.438.353-2.146.333-4.043.415-5.332.993-.792.357-.837.475-1.024.764a.752.752 0 0 0-.099.341c-.002.022.016.307.038.391a1.056 1.056 0 0 0 .715.76c.098.031.695.081.758.087 1.44.145 2.233-.205 3.641-.76 6.975-2.783 26.934-1.94 31.33-1.109 1.909.38 4.856.778 6.683 1.825.298.163.577.282.832.359.128.039.251.058.364.085.28.066.578.006.628-.004.1-.019.197-.048.285-.086.177-.075.32-.184.388-.316.049-.095.11-.278.139-.429a1.518 1.518 0 0 0-.008-.364z"
						/>
						<path
							fill="#333333"
							d="M9.143 40.979H7.29l1.632 8.332h2.144l1.247-5.64 1.259 5.64h2.144l1.713-8.332h-1.736l-1.049 6.375-1.364-6.375h-1.806l-1.387 6.351-.944-6.351zm14.609 0h-5.209v8.332h5.326v-1.399h-3.566v-2.074h3.042V44.44h-3.042v-2.063h3.45v-1.398h-.001zm1.485 0v8.332h3.1c1.958 0 2.89-.932 2.89-2.331 0-1.783-1.573-1.981-1.573-1.981s1.119-.478 1.119-1.865c0-1.399-.897-2.156-2.75-2.156h-2.786v.001zm1.76 3.508v-2.203h.583c1.037 0 1.457.349 1.457 1.084 0 .746-.42 1.119-1.282 1.119h-.758zm0 3.52v-2.249h1.072c.897 0 1.387.35 1.387 1.095 0 .746-.454 1.154-1.492 1.154h-.967zm6.258 1.421c.536 0 .909-.373.909-.897 0-.536-.373-.862-.886-.862-.536 0-.921.338-.921.886.001.489.304.873.898.873zm2.419-8.449v8.332h2.074c2.867 0 4.335-1.631 4.335-4.242 0-2.552-1.294-4.091-4.16-4.091h-2.249v.001zm1.76 6.934v-5.536h.478c1.608 0 2.389.956 2.389 2.808 0 1.841-.757 2.727-2.377 2.727h-.49v.001zm11.18-6.934h-5.209v8.332h5.326v-1.399h-3.566v-2.074h3.042V44.44h-3.042v-2.063h3.449v-1.398z"
						/>
					</svg>
					<svg v-if="brand === 'gmx'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123 40">
						<path
							style="fill:#1c449b;fill-opacity:1"
							d="m 109.17,18.84 10.66,-17.75 -10.88,0 -5.67,9 -6.1,-9 -11.92,0 12.57,17.73 -12.57,20 11.92,0 6.8,-11.37 8.06,11.37 10.64,0 z M 69.75,1.09 61.66,21.28 53.99,1.09 l -9.67,0 -6.42,37.78 9.77,0 3.16,-21.77 0.1,0 8.66,21.77 3.91,0 9.07,-21.77 0.12,0 2.75,21.77 9.82,0 -5.72,-37.78 z m -49.8,16.71 0,7.68 8,0 C 27.53,29.79 24.27,32 20.05,32 13.63,32 10.16,26.09 10.16,20.25 10.16,14.41 13.49,8.4 19.9,8.4 c 3.94,0 6.76,2.38 8.11,5.95 l 9.26,-3.88 C 34.04,3.47 28.06,0 20.34,0 8.25,0 0,8 0,20.19 0,32 8.2,40 20,40 26.27,40 31.8,37.76 35.46,32.64 38.75,28 39.2,23.28 39.3,17.8 Z"
						/>
					</svg>
					<svg v-if="brand === 'einsundeins'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401 401">
						<path fill="#fff" d="M.4.9h400v400H.4z"></path>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							fill="#003d8f"
							d="M9.8 10.2h381.3v381.3H9.8V10.2zm265.8 122v-29.1h65.2v181.1h-35.7v-152h-29.5zm-31.2 58c1.7 20-1.1 30.8-3.4 36.2l-28.2-38.3c29.6-20.8 36.9-54.8 13-76.5-19.8-14-40.1-14-61 0-21 19.3-19.6 42.6 4.2 69.8-40.7 25-44.1 52.9-26.5 82.4 18.8 27.8 60.7 34.3 97.1 10.5l7.1 9.7H285l-24.4-31.1c10.1-10 15.9-31.9 13.9-62.6h-30.1v-.1zm-55.9 15.5c-19.5 13-25.6 26.8-16 42 10.9 12.2 28.3 11.8 47.5 0l-31.5-42zm5.8-42l-8-11.8c-5.7-11.9-2.5-21.9 9.7-21.9 13.2.7 17.5 9.5 8.8 23.5l-10.5 10.2zM45.1 132.3v-29.1h65.2v181.1H74.6v-152H45.1z"
						/>
					</svg>
				</div>
				<div data-part="close-button">
					<label data-close-button="" :for="'burger' + id"><span></span><span></span></label>
				</div>
				<div data-part="content">
					<header>Alle Inhalte</header>
					<nav>
						<ul>
							<hp-tree-list v-for="(element, index) in elements" :key="index" :element="element"></hp-tree-list>
						</ul>
					</nav>
				</div>
			</div>
		</div>
		<div data-burger-layer @click="close"></div>
	</div>
</template>
